import { canDo } from './Plans';
import { Coffee } from 'lucide-react';
import { useState } from 'react';
import { api } from '../lib/api';
import type { Child } from '../lib/types';
import { Sheet } from '../ui/Sheet';
import { useParent } from './ParentContext';

function BreakSheet({ child, onClose }: { child: Child; onClose: () => void }) {
  const { replaceChild, toast } = useParent();
  async function start(minutes: number) {
    try {
      replaceChild(await api.post<Child>(`/api/children/${child.id}/break`, { minutes }));
      onClose();
    } catch (e) {
      toast({ text: (e as Error).message, tone: 'alert' });
    }
  }
  return (
    <Sheet title={`Break for ${child.name}`} onClose={onClose}>
      <p className="muted">Monitoring pauses during the break: no live view and no website log. It starts again on its own.</p>
      <div className="grid-buttons">
        {[5, 10, 15, 30].map((m) => (
          <button key={m} className="btn big" onClick={() => start(m)}>
            {m} min
          </button>
        ))}
      </div>
    </Sheet>
  );
}

/** The break button used on the family cards and the child page. */
export function QuickActions({ child, compact }: { child: Child; compact?: boolean }) {
  const { replaceChild, toast } = useParent();
  const [sheet, setSheet] = useState(false);
  const p = child.policy;

  // Co-parents without permission for school time (#471) don't get these controls; the server refuses them anyway.
  if (!canDo(child, 'school_time', 'edit')) return null;

  async function endBreak() {
    try {
      replaceChild(await api.post<Child>(`/api/children/${child.id}/break`, { minutes: 0 }));
    } catch (e) {
      toast({ text: (e as Error).message, tone: 'alert' });
    }
  }

  return (
    <>
      <div className={`actions ${compact ? 'compact' : ''}`}>
        {p.onBreak ? (
          <button className="btn" onClick={endBreak}>
            <Coffee size={18} /> End break
          </button>
        ) : (
          <button className="btn" onClick={() => setSheet(true)} disabled={!p.schoolTime}>
            <Coffee size={18} /> Break
          </button>
        )}
      </div>
      {sheet && <BreakSheet child={child} onClose={() => setSheet(false)} />}
    </>
  );
}
